import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgModule } from '@angular/core';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import {
    CURRENCY_MASK_CONFIG,
    CurrencyMaskConfig,
    CurrencyMaskModule,
} from 'ng2-currency-mask';
import { NgxChartsModule } from '@swimlane/ngx-charts';

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
    align: 'left',
    allowNegative: false,
    decimal: ',',
    precision: 2,
    prefix: '',
    suffix: '',
    thousands: '.',
};

@NgModule({
    imports: [NgxMaskDirective, NgxMaskPipe, NgIdleKeepaliveModule.forRoot()],
    providers: [
        provideNgxMask(),
        { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig },
    ],
    exports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        NgbModule,
        NgIdleKeepaliveModule,
        CurrencyMaskModule,
        NgxChartsModule,
        NgxMaskDirective,
        NgxMaskPipe,
    ],
})
export class SharedLibsModule {}
